<template>
  <div>
    <TopBar :page="topBarData"/>
    <v-container fluid>
      <v-row class="justify-center">
        <v-col cols="12" md="6">
          <Notes :id="productId" notesType="product" :formatNote="true"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import TopBar from '../../components/Layout/TopBar';
import Notes from '@/components/Globals/Notes/Notes';

export default {
  components: {
    TopBar,Notes
  },

  data() {
    return {
      productId: this.$route.params.id,
      topBarData: {
        name: 'loading...',
        type: 'blank',
        breadcrumbs: [
          {
            text: 'Billing Accounts',
            disabled: false,
            href: '/accounts/',
          }
        ],
        showBeehiveIcon: false,
      },
    }
  },

  computed: {
    ...mapState('accounts', ['currentAccount']),
    ...mapState('products', ['currentProduct']),
  },

  async mounted() {
    let promise = await this.fetchMainProduct(this.productId);
    await Promise.all(Object.values(promise));
    let currentAccount = this.currentAccount,
      accountId = currentAccount.id,
      productId = this.currentProduct.id,
      topBarDataName = `${accountId} - ${currentAccount.business_name}`;
    this.topBarData.name = topBarDataName;
    this.topBarData.breadcrumbs.push(
      {text: topBarDataName, href: `/accounts/${accountId}/`},
      {text: 'Product', disabled: true, href: '#'},
      {text: productId, href: `/products/${productId}`},
      {text: 'History', disabled: true, href: '#'},
    );
  },

  methods: {
    ...mapActions('products', ['fetchMainProduct']),
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .notes {
    max-height: 84vh !important;
  }

  ::v-deep .notes-text {
    position: static !important;
  }  
</style>